import styled from 'styled-components';

export const Container = styled.div`
  background: ${props => props.theme.colors.background};
  color: ${props => props.theme.colors.text};
  display: flex;
  align-items: center;
  justify-content: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Content = styled.div`
  width: 100%;
  max-width: 1200px;
  padding: 0 30px;

  @media (max-width: 768px) {
    padding: 0px;
  }
`;